import { isValidElement } from 'react';

const isElement = (element: any): boolean => {
  return isValidElement(element);
};

const isString = (element: any): boolean => {
  return typeof element === 'string';
};

export { isString, isElement };
